import Layout from './components/layout/layout'
import { ApiProvider } from '@yuno/dashboard-api-mfe'
import { ContainerProvider } from './context/container-context'
import { useCallback, useEffect } from 'react'
import { useAuth0 } from '@yuno/dashboard-authentication-mfe'
import { SnackbarProvider, useInitLang } from './yuno-dashboard-container-mfe'
import { InactiveSessionProvider } from './context/inactive-session-context'
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'
import { InactiveDialogContainer } from './components/layout/inactive-dialog/inactive-dialog-container'
import en from './lang/en.json'
import es from './lang/es.json'
import pt from './lang/pt.json'

export function LayoutRoot() {
  const i18Instance = useInitLang({ i18n: i18next, en, es, pt })
  const { getAccessTokenSilently } = useAuth0()
  const isProd = process.env.ENVIRONMENT === 'PROD'

  const fetchToken = useCallback(async () => {
    const token = await getAccessTokenSilently({
      scope: 'read:current_user update:current_user_metadata enroll:mfa',
    })

    localStorage.setItem('token', token)
    localStorage.setItem(
      'headers',
      JSON.stringify({
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      }),
    )

    window.dispatchEvent(
      new StorageEvent('storage', { key: 'token', newValue: token }),
    )
  }, [])

  useEffect(() => {
    fetchToken()
  }, [])

  return (
    <ApiProvider>
      <InactiveSessionProvider>
        <ContainerProvider>
          <SnackbarProvider>
            <I18nextProvider i18n={i18Instance}>
              <Layout />
              {(isProd || localStorage.getItem('enabled_inactive_dialog')) && (
                <InactiveDialogContainer />
              )}
            </I18nextProvider>
          </SnackbarProvider>
        </ContainerProvider>
      </InactiveSessionProvider>
    </ApiProvider>
  )
}
